import React, { useEffect, useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./home.css";
import { Context } from "../../context/Context";
import Header from "../../components/header/Header";
import axios from "axios";
import { toast } from "react-toastify";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { decodeHtml } from "../../utils/utils";
import { Helmet } from "react-helmet";

function AutoPlayCarousel({ children, ...carouselProps }) {
  const ref = React.useRef(null);
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.25 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, []);

  return (
    <div ref={ref}>
      {isVisible && (
        <Carousel
          autoPlay
          interval={3000}
          transitionTime={600}
          infiniteLoop
          showThumbs={false}
          showStatus={false}
          emulateTouch
          swipeable
          stopOnHover={false}
          {...carouselProps}
        >
          {children}
        </Carousel>
      )}
    </div>
  );
}

export default function Home() {
  const [posts, setPosts] = useState([]);
  const [users, setUsers] = useState([]);
  const [category, setCategory] = useState([]);
  const { user } = useContext(Context);
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const res = await axios.get("/posts/top-posts");

        if (res.status == 200) {
          setPosts(res.data);
        }
      } catch (err) {
        console.error("Error fetching posts! " + err);
        toast.error("Error Fetching Posts!");
      }
    };

    const fetchUsers = async () => {
      try {
        const res = await axios.get("/posts/top-users");

        if (res.status == 200) {
          setUsers(res.data);
        }
      } catch (err) {
        console.error("Error fetching posts! " + err);
        toast.error("Error Fetching Posts!");
      }
    };

    const fetchCategories = async () => {
      try {
        const res = await axios.get("/categories");

        if (res.status == 200) {
          setCategory(res.data);
        }
      } catch (err) {
        console.error("Error fetching posts! " + err);
        toast.error("Error Fetching Posts!");
      }
    };
    fetchCategories();
    fetchUsers();
    fetchPosts();
  }, []);

  return (
    <>
      <Helmet>
        <title>For Love of Writers — Curated Ideas. Powerful Voices.</title>
        <meta
          name="description"
          content="For Love of Writers is a digital publication that celebrates curiosity, culture, and creativity through diverse and original voices."
        />
        <meta property="og:title" content="For Love of Writers — Curated Ideas. Powerful Voices." />
        <meta
          property="og:description"
          content="Explore original writing from emerging and established voices who ignite curiosity and spark imagination."
        />
        <meta property="og:url" content="https://www.forloveofwriters.com" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="For Love of Writers — Curated Ideas. Powerful Voices." />
        <meta
          name="twitter:description"
          content="A digital publication celebrating curiosity, culture, and creativity through diverse and original voices."
        />
      </Helmet>
      <div className="BodyHome">
        <section className="hero-section">
          <Header />
          <picture className="hero-image-wrapper">
            <source
              srcSet="https://myflowimages.s3.us-east-2.amazonaws.com/frontend/Homepage.webp"
              type="image/webp"
            />
            <source
              srcSet="https://myflowimages.s3.us-east-2.amazonaws.com/frontend/Homepage.jpg"
              type="image/jpeg"
            />
            <img
              src="https://myflowimages.s3.us-east-2.amazonaws.com/frontend/Homepage.jpg"
              alt="For Love of Writers Hero"
              width="1920"
              height="1080"
              loading="eager"
              fetchpriority="high"
              className="hero-image"
            />
          </picture>

          <div className="container-home">
            <div className="content">
              <div className="centered-text">
                <div className="intro-text">
                  <p>SPARK IMAGINATION.</p>
                  <p>IGNITE CURIOSITY.</p>
                </div>
                <button className="centered-btn">
                  <Link
                    to="/articles"
                    style={{ textDecoration: "none", color: "#B1E5F2" }}
                  >
                    Browse Articles
                  </Link>
                </button>
              </div>
            </div>
          </div>
        </section>

        <div className="containertwo">

          <div className="section">

            <div className="image">
              <div className="carousel-container">
                <AutoPlayCarousel
                  showThumbs={false}
                  showStatus={false}
                  infiniteLoop
                  useKeyboardArrows
                  autoPlay
                  interval={3000} // 3 seconds
                  transitionTime={600}
                  swipeable={true}
                  emulateTouch={true}
                  stopOnHover={false}
                  renderArrowPrev={(clickHandler, hasPrev, labelPrev) =>
                    hasPrev && (
                      <button
                        type="button"
                        className="control-arrow control-prev"
                        onClick={clickHandler}
                      >
                        &#10094;
                      </button>
                    )
                  }
                  renderArrowNext={(clickHandler, hasNext, labelNext) =>
                    hasNext && (
                      <button
                        type="button"
                        className="control-arrow control-next"
                        onClick={clickHandler}
                      >
                        &#10095;
                      </button>
                    )
                  }
                >
                  {posts.map((p) => (
                    <Link key={p._id} to={`/${p.post_slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                      <div>
                        <img
                          loading="lazy"
                          src={
                            p.photo.startsWith("http")
                              ? p.photo
                              : `${process.env.REACT_APP_AWS_S3_IMAGE_URL}${p.photo}`
                          }
                          alt={p.post_slug}
                          className="carousel-image"
                        />
                        <div className="caption">{p.title}</div>
                      </div>
                    </Link>
                  ))}
                </AutoPlayCarousel>
              </div>
            </div>

            <div className="text">
              <div className="text-button">
                <h1 style={{ fontSize: "36px" }}>
                  Embark on a Literary Journey
                </h1>
                <p style={{ paddingLeft: "20px", fontSize: "24px", width: "405px", fontWeight:"400", color:"#272635" }}>
                  Dive into our expansive collection of articles that blend reality and imagination. From groundbreaking discoveries to creative fiction, our pieces captivate and enlighten.
                </p>
                <button>
                  <Link
                    to="/articles"
                    style={{ textDecoration: "none", color: "#B1E5F2" }}
                  >
                    Explore Our Articles
                  </Link>
                </button>
              </div>
            </div>
          </div>

          <div className="section">

            <div className="image">
              <div className="text-button">
                <h1 style={{ fontSize: "36px" }}>Discover Your Next Passion</h1>
                <p style={{ paddingLeft: "40px", fontSize: "24px", width: "405px", fontWeight:"400", color:"#272635" }}>
                  Our collection is a treasure trove of genres, perfect for every curious mind. Whether you’re into science, travel, nature, or the unexpected, we’ve got something for you.
                </p>
                <button>
                  <Link
                    to="/categories"
                    style={{ textDecoration: "none", color: "#B1E5F2" }}
                  >
                    Choose Your Genre
                  </Link>
                </button>
              </div>
            </div>

            <div className="text">
              <div className="carousel-container">
                <AutoPlayCarousel
                  showThumbs={false}
                  showStatus={false}
                  infiniteLoop
                  useKeyboardArrows
                  autoPlay
                  interval={3000} // 3 seconds
                  transitionTime={600}
                  swipeable={true}
                  emulateTouch={true}
                  stopOnHover={false}
                  renderArrowPrev={(clickHandler, hasPrev, labelPrev) =>
                    hasPrev && (
                      <button
                        type="button"
                        className="control-arrow control-prev"
                        onClick={clickHandler}
                      >
                        &#10094;
                      </button>
                    )
                  }
                  renderArrowNext={(clickHandler, hasNext, labelNext) =>
                    hasNext && (
                      <button
                        type="button"
                        className="control-arrow control-next"
                        onClick={clickHandler}
                      >
                        &#10095;
                      </button>
                    )
                  }
                >
                  {category.map((c) => (
                    <Link key={c._id} to={`/category/${c.cat_slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                      <div>
                        <img
                          loading="lazy"
                          src={
                            c.cat_image
                              ? `${process.env.REACT_APP_AWS_S3_IMAGE_URL}${c.cat_image}`
                              : `https://ui-avatars.com/api/?name=${c.cat_slug}&background=random`
                          }
                          alt={c.cat_slug}
                          className="carousel-image"
                        />
                        <div className="caption">{decodeHtml(c.cat_name)}</div>
                      </div>
                    </Link>
                  ))}
                </AutoPlayCarousel>
              </div>
            </div>
          </div>

          <div className="section">

            <div className="image">
              <div className="carousel-container">
                <AutoPlayCarousel
                  showThumbs={false}
                  showStatus={false}
                  infiniteLoop
                  useKeyboardArrows
                  autoPlay
                  interval={3000} // 3 seconds
                  transitionTime={600}
                  swipeable={true}
                  emulateTouch={true}
                  stopOnHover={false}
                  renderArrowPrev={(clickHandler, hasPrev, labelPrev) =>
                    hasPrev && (
                      <button
                        type="button"
                        className="control-arrow control-prev"
                        onClick={clickHandler}
                      >
                        &#10094;
                      </button>
                    )
                  }
                  renderArrowNext={(clickHandler, hasNext, labelNext) =>
                    hasNext && (
                      <button
                        type="button"
                        className="control-arrow control-next"
                        onClick={clickHandler}
                      >
                        &#10095;
                      </button>
                    )
                  }
                >
                  {users.map((u) => (
                    <Link key={u._id} to={`/author/${u.userId}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                      <div>
                        <img
                          loading="lazy"
                          src={
                            u.avatar_urls?.full
                              ? `${process.env.REACT_APP_AWS_S3_IMAGE_URL}${u.avatar_urls.full}`
                              : u.profilePic
                          }
                          alt={u.user_slug}
                          className="carousel-image"
                        />
                        <div className="caption">{u.user_name}</div>
                      </div>
                    </Link>
                  ))}
                </AutoPlayCarousel>
              </div>
            </div>

            <div className="text">
              <div className="text-button">
                <h1 style={{ fontSize: "36px" }}>Meet the Minds Behind the Words</h1>
                <p style={{ paddingLeft: "70px", fontSize: "24px", width: "405px", fontWeight:"400", color:"#272635" }}>
                  Our writers are the heartbeat of our movement, bringing diverse perspectives and expertise to the forefront. Meet the talented writers who bring our content to life.
                </p>
                <button>
                  <Link
                    to="/authors"
                    style={{ textDecoration: "none", color: "#B1E5F2" }}
                  >
                    Meet Our Writers
                  </Link>
                </button>
              </div>
            </div>

          </div>
        </div>

        {!user && (
          <div className="subscribe-section">
            <h1
              style={{
                textAlign: "center",
                fontSize: "48px",
                fontWeight: "500",
                paddingBottom: "10px",
              }}
            >
              Get Free Access!
            </h1>
            <p
              style={{
                textAlign: "center",
                marginBottom: "10px",
                fontSize: "32px",
                fontWeight: "400",
              }}
            >
              Sign up and receive access to 5 free articles!
            </p>
            <form
              style={{ alignItems: "center", paddingTop: "15px" }}
              onSubmit={(e) => {
                e.preventDefault();

                if (!email || !email.includes("@")) {
                  toast.info("Please enter a valid email.");
                  return;
                }

                const cleanedEmail = email.trim().toLowerCase();
                navigate(`/register?email=${encodeURIComponent(email.trim())}`);
              }}
            >
              <input
                type="email"
                className="signup-email"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button
                type="submit"
                style={{
                  backgroundColor: "#272635",
                  color: "#FFFCFC",
                  height: "75px",
                  width: "209px",
                  border: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                  fontSize: "36px",
                  fontWeight: "700",
                  boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                }}
              >
                Sign Up
              </button>
            </form>
          </div>
        )}

      </div>
    </>
  );
}
